const CONFIG = {
  BASE_URL: 'https://restaurant-api.dicoding.dev/',
  BASE_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/medium/',
  DEFAULT_LANGUAGE: 'en-us',
  BASE_URL_MEAL: 'https://www.themealdb.com/api/json/v1/1/filter.php?a=Japanese',
  CACHE_NAME: 'findaurant-cache',
  DATABASE_NAME: 'restaurant-apps-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurants',
};

export default CONFIG;
